export default __webpack_public_path__ + "static/media/rank.8a60d3fb.svg";